import React from 'react'
import { ThemeProvider } from '@mui/material/styles'
import { useKiotFieldSurfaceTheme } from '@/theme/useKiotFieldSurfaceTheme'
import { FieldSurfaceProvider } from './FieldSurfaceContext'
import type { FieldSurface } from './fieldSurfaces/types'

type FieldSurfaceThemeProviderProps = {
  surface: FieldSurface
  children: React.ReactNode
}

/** Bọc vùng field — theme MUI + context surface (`form` | `filterToolbar` | `filterSidebar` | `pos` | `posUnderline`). */
export function FieldSurfaceThemeProvider({ surface, children }: FieldSurfaceThemeProviderProps) {
  const theme = useKiotFieldSurfaceTheme(surface)
  return (
    <FieldSurfaceProvider surface={surface}>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </FieldSurfaceProvider>
  )
}

export default FieldSurfaceThemeProvider
